import { useEffect, useState } from "react";
import Navbar from "../components/Navbar";

export default function Logs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const res = await fetch("http://localhost:5000/logs");
      const data = await res.json();
      setLogs(data.reverse()); // latest first
    } catch {
      setLogs([]);
    }
    setLoading(false);
  };

  const clearLogs = async () => {
    await fetch("http://localhost:5000/logs", {
      method: "DELETE",
    });
    fetchLogs();
  };

  useEffect(() => {
    fetchLogs();
  }, []);

  return (
    <>
      <Navbar />

      <div className="bg-gray-900 min-h-screen p-6 text-white">
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-xl font-bold">Execution Logs</h1>

          <div className="flex gap-2">
            <button
              onClick={fetchLogs}
              className="bg-gray-700 px-4 py-2 rounded"
            >
              Refresh
            </button>
            <button
              onClick={clearLogs}
              className="bg-red-600 hover:bg-red-700 px-4 py-2 rounded"
            >
              Clear Logs
            </button>
          </div>
        </div>

        {loading ? (
          <p className="text-gray-400">Loading logs...</p>
        ) : logs.length === 0 ? (
          <p className="text-gray-400">No logs available</p>
        ) : (
          <div className="space-y-4">
            {logs.map((log, idx) => (
              <div
                key={idx}
                className="border border-gray-700 rounded-lg p-4 bg-gray-800"
              >
                <div className="flex justify-between items-center mb-2">
                  <div className="text-sm">
                    <span className="font-semibold capitalize">
                      {log.language}
                    </span>{" "}
                    • {new Date(log.timestamp).toLocaleString()}
                  </div>

                  <span
                    className={`text-xs px-2 py-1 rounded ${
                      log.status === "SUCCESS"
                        ? "bg-green-600"
                        : log.status === "TLE"
                        ? "bg-yellow-600"
                        : "bg-red-600"
                    }`}
                  >
                    {log.status}
                  </span>
                </div>

                <p className="text-xs text-gray-400 mb-1">
                  Execution Time: {log.executionTimeMs} ms
                </p>

                {log.input && (
                  <>
                    <p className="text-xs text-gray-400">Input</p>
                    <pre className="bg-black p-2 rounded text-green-400 text-xs overflow-auto">
                      {log.input}
                    </pre>
                  </>
                )}

                <p className="text-xs text-gray-400 mt-2">Output</p>
                <pre className="bg-black p-2 rounded text-green-400 text-xs overflow-auto">
                  {log.output}
                </pre>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
}
